export const QA_NAME_LOADER_ICON = 'loader'
